// SVG icons used by the V2d tracking screen. Small stroke-based icons that
// inherit `currentColor` so chip tones drive their color automatically.

import React from "react";

export const ICON_PATHS = {
  close: "M6 6l12 12M18 6L6 18",
  check: "M5 12.5l5 5L20 7",
  phone:
    "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
  swap: "M7 10h13M7 10l4-4M7 10l4 4M17 14H4M17 14l-4-4M17 14l-4 4",
  stop: "M9 9h6v6H9z M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z",
  ghost:
    "M12 2a7 7 0 0 0-7 7v10l3-2 2 2 2-2 2 2 3-2V9a7 7 0 0 0-5-7zM9 10h.01M15 10h.01",
  note: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M9 13h6M9 17h4",
  car: "M5 17h14v-3l-2-5H7L5 14v3zM7.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM16.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z",
  alert:
    "M12 9v4M12 17h.01M10.3 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z",
  chevronLeft: "M15 6l-6 6 6 6",
  chevronDown: "M6 9l6 6 6-6",
  chevronUp: "M18 15l-6-6-6 6",
  loupe: "M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z",
  clock: "M12 7v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z",
  calendar: "M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
};

export function Icon({ path, size = 18, sw = 2, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      aria-hidden="true"
    >
      <path d={path} />
    </svg>
  );
}
